import { INVOICE_SUBTYPES, INVOICE_TYPES } from 'Utils/constants';

const CORRECTIVE_SUBTYPES = [INVOICE_SUBTYPES.STANDARD_CORRECTIVE, INVOICE_SUBTYPES.SIMPLIFIED_CORRECTIVE];

// Importe de la factura con el signo del movimiento de caja que se espera:
// compras en negativo, ventas en positivo y las rectificativas invierten el signo.
export const getInvoiceReconciliationAmount = (invoice) => {
    const amount = invoice?.amount_uc ?? 0;
    const signedAmount = invoice?.type === INVOICE_TYPES.PURCHASE ? -amount : amount;

    return CORRECTIVE_SUBTYPES.includes(invoice?.subtype) ? -signedAmount : signedAmount;
};

// Importe real del movimiento bancario. Ignora `reverse_sign` ("Marcar como devolución") a propósito:
// ese flag solo cambia cómo se agrupa la transacción en etiquetas, no el dinero que se ha movido.
export const getTransactionReconciliationAmount = (transaction) => transaction?.amount_uc ?? 0;

// Redondea a céntimos para que sumas como -140.95 + 26.95 (= -113.99999999999999) no generen descuadres fantasma.
export const getReconciliationPendingAmount = (expectedAmount, associatedTotal) => {
    const pendingAmount = Math.round((expectedAmount - associatedTotal) * 100) / 100;

    // Evita mostrar "-0,00 €"
    return pendingAmount === 0 ? 0 : pendingAmount;
};
